import { useContext } from 'react';
import { QueryApiContext } from '../contexts/QueryContext';
import { AuthContext } from '../contexts/AuthContext';
import { AuthObject } from '../utils/frontEndTypes';

export function usePendingInvites() {
  const restQueryClient = useContext(QueryApiContext);
  const auth = useContext(AuthContext) as AuthObject;

  const { data, isLoading } = restQueryClient.invites.listMine.useQuery(['myPendingInvites'], undefined, {
    enabled: !!auth.user?.id,
    refetchOnWindowFocus: true,
    staleTime: 60_000
  });

  const pendingInvites = data?.status === 200 ? data.body.data : [];
  const pendingCount = pendingInvites.length;

  return { pendingInvites, pendingCount, isLoading };
}
